module.exports = __webpack_public_path__ + "img/upgrade-estate.b3fd5095.png";